import axios from "axios";
import User from "../models/user";
import authHeader from "@/services/auth-header";
import { ApiService } from "@/services/api.service";
import environments from "../utils/environments";

const API_URL = environments.apiUrl + "/api/vouchers/attachment";

class VoucherAttachmentService {
  getMetaForAttachments(rechnungId: any) {
    return ApiService.post(API_URL + "/meta", { voucherId: rechnungId });
  }

  downloadAttachment(id: any) {
    return ApiService.post(API_URL + "/get", { attachmentId: id });
  }
}

export default new VoucherAttachmentService();
